import React from 'react';
import { ThemeProvider, withTheme } from 'styled-components';
import cuid from 'cuid';
// eslint-disable-next-line import/no-cycle
import useConfig from '../hooks/useConfig';
import { sectionSeperatorTheme } from './theme';
import Wrapper from './Wrapper';
export var TypeVariants;
(function (TypeVariants) {
    TypeVariants["Default"] = "type-default";
    TypeVariants["Type1"] = "type-1";
    TypeVariants["None"] = "";
})(TypeVariants || (TypeVariants = {}));
var styleTypeVariants = function (type) {
    switch (type) {
        case 'type1':
            return TypeVariants.Type1;
        case 'default':
            return TypeVariants.Default;
        default:
            return TypeVariants.Default;
    }
};
var SectionSeperator = function (_a) {
    var _b, _c;
    var contentData = _a.contentData, _d = _a.componentKey, componentKey = _d === void 0 ? cuid() : _d;
    var _e = contentData.field_style_type, styleType = _e === void 0 ? '' : _e, marginVariant = contentData.field_margin_variant;
    var renderIcons = styleType === 'type1';
    var config = useConfig();
    return (React.createElement(ThemeProvider, { theme: sectionSeperatorTheme },
        React.createElement(Wrapper, { styleType: styleType, marginVariant: marginVariant, className: "section-seperator " + styleTypeVariants(styleType), key: componentKey, tabletMinWidth: (_c = (_b = config === null || config === void 0 ? void 0 : config.mediaBreakpoints) === null || _b === void 0 ? void 0 : _b.values) === null || _c === void 0 ? void 0 : _c.tabletMinWidth },
            React.createElement("div", { className: "inner" }, renderIcons && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "icon icon-1" }),
                React.createElement("div", { className: "icon icon-2" }),
                React.createElement("div", { className: "icon icon-3" })))))));
};
export default withTheme(SectionSeperator);
//# sourceMappingURL=index.js.map